import { Card } from '@/shared/ui/card';

interface PublicInviteMobileHandoffProps {
  /** URL que, aberta no celular, retoma a entrega do cartão (sem repetir o cadastro). */
  handoffUrl: string;
}

/**
 * Tela nova (não existe no legado) para quem conclui o cadastro pelo
 * computador: o cartão só pode ser instalado direto no Wallet do celular, então
 * mostramos um QR para o usuário escanear e continuar por lá. Reaproveita o
 * mesmo padrão de QR já usado em account-qr-code-page.tsx /
 * operator-register-invite.tsx (imagem simples via api.qrserver.com, sem lib nova).
 */
export function PublicInviteMobileHandoff({ handoffUrl }: PublicInviteMobileHandoffProps) {
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=280x280&margin=8&data=${encodeURIComponent(handoffUrl)}`;
  const whatsappUrl = `https://wa.me/send?text=${encodeURIComponent(handoffUrl)}`;

  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-xl font-semibold">⏳ Não feche esta página ainda!</h1>
      <p className="mt-3 font-medium">Agora falta só um passo.</p>
      <p className="mt-2 text-sm text-muted-foreground">
        Seu cadastro foi realizado com sucesso, mas é pelo celular que você conclui a instalação e
        garante acesso fácil ao seu cartão e aos seus benefícios.
      </p>
      <p className="mt-4 text-sm text-muted-foreground">
        Escaneie o QR Code agora e adicione seu cartão à carteira digital do seu celular.
      </p>
      <div className="mx-auto mt-6 w-fit rounded-2xl bg-white p-3 shadow-glass ring-1 ring-black/5">
        <img
          src={qrSrc}
          alt="QR Code para instalar o cartão no celular"
          width={240}
          height={240}
          className="rounded-xl"
        />
      </div>

      <a
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        className="mt-6 inline-flex flex-col items-center gap-2"
      >
        <span className="grid size-11 place-items-center rounded-full bg-[#25D366] text-white shadow-soft transition-transform hover:scale-105">
          <svg viewBox="0 0 24 24" className="size-5 fill-current" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
          </svg>
        </span>
        <span className="text-xs text-muted-foreground">
          Clique aqui e envie o link para o seu WhatsApp
        </span>
      </a>

      <a href={handoffUrl} className="mt-4 block break-all text-xs text-primary hover:underline">
        {handoffUrl}
      </a>
    </Card>
  );
}
